import { forwardRef } from 'react'

import { IconProps, IconVariants } from '../IconVariants'
const EditIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size, ...props }, ref) => {
  return (
    <svg
      aria-hidden="true"
      className={IconVariants({
        class: className,
        size,
      })}
      fill="none"
      height="1em"
      ref={ref}
      viewBox="0 0 24 24"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M18.1414 3.14142C18.0633 3.06331 17.9367 3.06331 17.8586 3.14142L15.8787 5.12132L18.7071 7.94975L20.687 5.96985C20.7651 5.89174 20.7651 5.76511 20.687 5.687L18.1414 3.14142ZM15 6L17.8284 8.82842L8.63601 18.0208L5.80759 15.1924L15 6ZM4.32679 19.8118C4.16975 19.8651 4.01977 19.7151 4.0731 19.5581L5.39714 15.6593L8.22557 18.4877L4.32679 19.8118Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  )
})
EditIcon.displayName = 'EditIcon'
export default EditIcon
